import { BulkProvisioningJobs } from './BulkProvisioningJobs.tsx';

import { BulkProvisioningFiltersURLParser } from './Filters/SearchParams/BulkProvisioningFiltersURLParser.tsx';
import { BulkProvisioningPageLayout } from './layout/BulkProvisioningPageLayout.tsx';

import { SomethingWentWrongErrorBoundary } from 'common/components/Fallbacks/SomethingWentWrongErrorBoundary.tsx';

export const BulkProvisioning = () => {
  return (
    <BulkProvisioningPageLayout>
      <SomethingWentWrongErrorBoundary>
        <BulkProvisioningFiltersURLParser>
          <BulkProvisioningJobs />
        </BulkProvisioningFiltersURLParser>
      </SomethingWentWrongErrorBoundary>
    </BulkProvisioningPageLayout>
  );
};
